import { fetchPointsBurnTiersLogic } from './fetchPointsBurnTiersLogic';

export const logic = [fetchPointsBurnTiersLogic];
